import alt from '../alt';
import uuid from 'uuid';

import NotificationActions from '../actions/NotificationActions'

class ChatActions {
    constructor() {
        this.generateActions('getMessagesSuccess', 'getSendMessageSuccess', 'clearMessageSent');
    }

    setSendMessageError(response) {
        const errors = {
            403: "Cannot send message. Your hiring has been deleted or is cancelled.",
            404: "Cannot send message. Candidate does not exist."
        };
        const hiringError = {
            statusCode: response.statusCode,
            text: errors[response.statusCode]
        };
        NotificationActions.showError(
            `Hiring:Error:${uuid.v4()}`,
            hiringError.text);
        this.dispatch(hiringError);
    }
}

export default alt.createActions(ChatActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/ChatActions.js
 **/